"use strict";
const TIMEOUT = 5, CORRECTANSWER = 1, ANSWER1 = 1, ANSWER2 = 2, ANSWER3 = 3, ANSWER4 = 4, OTHERANSWER = 6;

window.__playDebug = window.__playDebug || {
    enabled: true,
    log: function () {
        if (!this.enabled || !window.console) return;
        console.log.apply(console, ['[PLAY]'].concat([].slice.call(arguments)));
    },
    error: function () {
        if (!this.enabled || !window.console) return;
        console.error.apply(console, ['[PLAY][ERROR]'].concat([].slice.call(arguments)));
    }
};

class PlayScreenController {

    constructor(result, isChallenge) {
        var that = this;

        this.currentQuestion;
        this.currentQuestionIndex = 0;
        this.currentPollQuestionIndex = 0;
        this.gamePoints = 0;
        this.countDown;
        this.numQuestions = result.game.questions.length;
        this.question_response_max_time = this.getQuestionResponseMaxTime(result);
        this.question_points = this.getQuestionPoints(result);
        this.question_extra_time = world.question_extra_time;
        this.question_show_answer = this.getQuestionShowAnswer(result);
        this.completeRequest = this.createCompleteRequest(result.game);
        this.counterStartsAt;
        this.result = result;
        this.isChallenge = isChallenge;
        this.onCompleteTime = undefined;
        this.questionAnswered = false;

        this._trackingDocumentId = (!isChallenge && (result.is_doc_type_game_or_test || result.own_poll))
            ? result.document_id
            : null;
        this._trackingCheckpointAt = null;
        this._trackingClosed = false;
        this._trackingCheckpointConsumed = false;

        isChallenge ? ga('send', 'event', analytics.GA_CATEGORY_PLAY, analytics.GA_CATEGORY_PLAY_EVENT_NEW_CHALLENGE, user.user_world_id) : ga('send', 'event', analytics.GA_CATEGORY_PLAY, analytics.GA_CATEGORY_PLAY_EVENT_NEW_PLAY, user.user_world_id);

        $('body').off("click", '#closeResumeBtn');
        $(document).off("click", '#gameEndGameBtn');

        $(document).one("click", '#gameEndGameBtn', function () {
            if (that.timeoutForStartTimer != undefined) {
                clearTimeout(that.timeoutForStartTimer);
                that.timeoutForStartTimer = undefined;
            }
            that.stopCountDown();

            that._trackSessionClosed();

            that.currentQuestionIndex = that.numQuestions - 1;
            that.showNextQuestion(that.result);
            return false;
        });
    };

    _trackQuestionCheckpoint(isLastCheckpoint) {
        if (!this._trackingDocumentId || this._trackingClosed) {
            return;
        }

        const now = Date.now();
        const elapsedMs = now - this._trackingCheckpointAt;

        if (elapsedMs <= 0) {
            return;
        }

        const documentationProgress = documentationScreenController.documentationProgress;

        if (isLastCheckpoint) {
            this._trackingClosed = true;
            documentationProgress._trackingStop(this._trackingDocumentId, elapsedMs);
        } else {
            documentationProgress._trackingUpdate(this._trackingDocumentId, elapsedMs);
            this._trackingCheckpointConsumed = true;
        }
    }

    handleClosedBeforeFinishing() {
        this._trackSessionClosed();
    }

    _trackSessionClosed() {
        if (!this._trackingDocumentId || this._trackingClosed) {
            return;
        }

        if (this._trackingCheckpointConsumed) {
            this._trackingClosed = true;
            return;
        }

        this._trackQuestionCheckpoint(true);
    }

    getTimeOutId() {
        return TIMEOUT;
    }

    stopCountDown() {
        __playDebug.log(
            'TIMER_STOP',
            {
                qIndex: this.currentQuestionIndex
            }
        );
        if (this.countDown) this.countDown.stop();
    }

    getQuestionResponseMaxTime(result) {

        if (result.has_test) {
            if (result.is_doc_game_or_test) {
                return world.documentation_question_time / 1000;
            }
            if (result.is_doc_type_game_or_test) {
                return result.own_test.question_response_max_time;
            }
        } else if (result.is_doc_type_game_or_test) {
            return result.own_game.question_response_max_time;
        }

        return world.question_response_max_time / 1000;
    }

    getQuestionPoints(result) {

        if (!result.has_test && result.is_doc_type_game_or_test) {
            return result.own_game.question_points;
        }

        return world.question_points;
    }

    getQuestionShowAnswer(result) {

        if (!result.has_test && result.is_doc_type_game_or_test) {
            return result.own_game.question_show_answer;
        }

        return world.question_show_answer;

    }

    createCompleteRequest(game) {
        var completeRequest = new Object();

        completeRequest.game = new Object();
        completeRequest.game.questions = new Array();
        completeRequest.wildcards = new Object();
        completeRequest.world_token = world.token;
        completeRequest.game.game_id = game.game_id;
        completeRequest.wildcards.wildcard_resolve = 0;
        completeRequest.wildcards.wildcard_simplify = 0;
        completeRequest.wildcards.wildcard_time_extra = 0;

        return completeRequest;
    };

    createResponseQuestionObject(dataQuestion, responseTime, responseType, points) {

        var question = new Object();
        question.question_id = dataQuestion.id;
        question.response_time = responseTime;
        question.answer_type = responseType;
        question.points = points;

        this.completeRequest.game.questions.push(question);

        // IZE-9629 (FR-025, TASK-012): único punto compartido por Juego, Test y Encuesta donde se
        // registra cada pregunta respondida (incluye timeout, ver la llamada en `initCounter`) —
        // dispara tracking/update, o tracking/stop si es la última pregunta de la sesión.
        this._trackQuestionCheckpoint(this.completeRequest.game.questions.length >= this.numQuestions);
    };

    resolveWildCard(result) {
        var that = this;
        var resolveIcon = customIcons["RESOLVE"];

        $(document).one("click", '#resolveWildcardSection', function (event) {
            event.preventDefault();
            if (parseInt(result.wildcards.wildcard_resolve) > 0) {

                if (that.onResolveWildcard) that.onResolveWildcard();

                var correctAnswer = that.currentQuestion.correct_answer;

                $(".answerBtn").each(function () {
                    if ($(this).attr('data-answer') == correctAnswer) {
                        $(this).trigger('click');
                    }
                });
                //Sumamos uno para enviar al acabar
                that.completeRequest.wildcards.wildcard_resolve++;
                //Nos queda uno menos
                $('#solverCounterTxt').text(--result.wildcards.wildcard_resolve);
                $('#resolveWildcardLink').find('img').attr('src', resolveIcon);
                $('#resolveWildcardLink').addClass('disabled-link');
                $('#resolveWildcardSection').addClass('disabled-link');
                $('#resolveWildcardSection').find('p').removeClass('black-text');
            }
        });
    };

    simplifyWildCard(result) {
        var that = this;
        var simplifyIcon = customIcons["SIMPLIFY"];

        $("#simplifyWildcardSection").click(function (event) {
            event.preventDefault();
            if (parseInt(result.wildcards.wildcard_simplify) > 0 && !$('#simplifyWildcardLink').hasClass('disabled-link')) {
                var correctAnswer = that.currentQuestion.correct_answer;
                if ($(".answerBtn:visible").length > 2) {
                    $(".answerBtn").each(function () {
                        if ($(this).attr('data-answer') != correctAnswer && $(".answerBtn:visible").length > 2) {
                            $(this).hide();
                        }
                    });

                    //Sumamos uno para enviar al acabar
                    that.completeRequest.wildcards.wildcard_simplify++;
                    //Nos queda uno menos
                    $('#simplifyCounterTxt').text(--result.wildcards.wildcard_simplify);

                    $('#simplifyWildcardLink').find('img').attr('src', simplifyIcon);
                    $('#simplifyWildcardLink').addClass('disabled-link');
                    $('#simplifyWildcardSection').addClass('disabled-link');
                    $('#simplifyWildcardSection').find('p').removeClass('black-text');

                    $('#simplifyWildcardLink').unbind("click");
                }
            }
        });
    };

    extraTimeWildCard(result) {
        var that = this;
        var extraTimeIcon = customIcons["EXTRA_TIME"];

        $(document).one("click", '#timeExtraWildcardSection', function (event) {
            event.preventDefault();
            if (parseInt(result.wildcards.wildcard_time_extra) > 0) {

                var secondsElapsed = Math.round(that.countDown._iteration / 1000);

                //Aumentamos el timer
                if (secondsElapsed >= that.question_extra_time / 1000) {
                    that.countDown._iteration -= that.question_extra_time;
                    //  that.countDown.extendTimer(that.question_extra_time/1000);
                }
                else {
                    that.countDown._iteration = 0;
                }

                //Sumamos uno para enviar al acabar
                that.completeRequest.wildcards.wildcard_time_extra++;

                //Nos queda uno menos
                $('#timeExtraWildcardTxt').text(--result.wildcards.wildcard_time_extra);
            }

            $('#timeExtraWildcardLink').find('img').attr('src', extraTimeIcon);
            $('#timeExtraWildcardLink').addClass('disabled-link');
            $('#timeExtraWildcardSection').addClass('disabled-link');
            $('#timeExtraWildcardSection').find('p').removeClass('black-text');
        });
    };

    // Asume tiempos en milisegundos
    incorrectAnswerFormula(responseTime, maxTime) {

        // Fórmula ANTERIOR:
        // var points = this.question_points * (1/($('.answerBtn').length -1));
        // points = -1 * Math.max(1,Math.round  (points));

        let maxPoints = this.question_points;
        let numAnswers = this.getCurrentQuestionNumAnswers();

        // En el caso de que el númeor de respuestas sea 1, lo aumentamos a 2
        // para que no haya división por cero en la fórmula.
        if (numAnswers == 1) numAnswers = 2;

        // MAXIMOS_PUNTOS_A_PERDER = ABS(PUNTOS_MAXIMOS*(1/(NUMERO_RESPUESTAS-1)))
        let maxPointsToLose = Math.abs(maxPoints * (1 / (numAnswers - 1)));
        // MINIMOS_PUNTOS_A_PERDER = (MAXIMOS_PUNTOS_A_PERDER*50)/100
        let minPointsToLose = maxPointsToLose * 0.5;

        // (((TIEMPO_DE_RESPUESTA-1000)/(MAXIMO_TIEMPO_RESPUESTA-1000))*(MAXIMOS_PUNTOS_A_PERDER-MINIMOS_PUNTOS_A_PERDER)) -MAXIMOS_PUNTOS_A_PERDER
        let points = (((responseTime - 1000) / (maxTime - 1000)) * (maxPointsToLose - minPointsToLose)) - maxPointsToLose;

        // Eliminar decimales
        points = Math.round(points);

        // console.log({
        //     'responseTime': responseTime,
        //     'maxTime': maxTime,
        //     'maxPoints': maxPoints,
        //     'numAnswers': numAnswers,
        //     'points': points
        // });

        this.updateGamePoints(points);
        return points;
    };

    assessmentAnswerFormula(answerType){
        let currentQuestion = this.currentQuestion;
        let totalAnswers = currentQuestion.answer_3 ? (currentQuestion.answer_4 ? 4 : 3) : 2;
        return 1 - ((answerType-1) / (totalAnswers-1));
    };

    getCurrentQuestionNumAnswers() {

        let numAnswers = $('.answerBtn').length;

        if (this.currentQuestion.qtype == QTYPE_HOT_SPOT) {
            // En las preguntas de tipo HotSpot:
            // El número de .answerBtn es el doble porque están tanto en la imagen normal com en la modal de zoom
            // Existe un #hotSpotOtherBtn.answerBtn que se utiliza para fallar al pulsar en el fondo y no hay que contar
            numAnswers = (numAnswers - 1) / 2;
        }

        return numAnswers;

    }

    correctAnswerFormula(responseTime) {

        var points = this.question_points - (responseTime / (this.question_response_max_time * 1000)) * this.question_points;
        points = Math.max(1, Math.round(points));
        this.updateGamePoints(points);
        return points;
    };

    updateGamePoints(points) {
        this.gamePoints += points;
        $('#gamePointsTxt').text(sprintf(Translator.trans('TR_X_PUNTOS'), this.gamePoints));
        if (!this.isChallenge) {
            if (points >= 0) {
                $('#challengeAnswerBadge').addClass('challengeAnswerBadgeCorrect').text(sprintf(Translator.trans('TR_X_PUNTOS'), points));
            }
            else {
                $('#challengeAnswerBadge').addClass('challengeAnswerBadgeIncorrect').text(sprintf(Translator.trans('TR_X_PUNTOS'), points));
            }
        }
    };

    drawQuestion(result) {
        var that = this;
        var template;

        if (this._trackingDocumentId) {
            this._trackingCheckpointAt = Date.now();
            this._trackingCheckpointConsumed = false;
        }

        __playDebug.log(
            'DRAW_QUESTION_START',
            {
                qIndex: this.currentQuestionIndex,
                exists: !!result.game.questions[this.currentQuestionIndex],
                qId: result.game.questions[this.currentQuestionIndex]?.question?.id,
                qType: result.game.questions[this.currentQuestionIndex]?.question?.qtype
            }
        );

        if (this._currentStrategy && this._currentStrategy.cancel) {
            this._currentStrategy.cancel();
            this._currentStrategy = null;
        }

        this.questionAnswered = false;

        this.currentQuestion = result.game.questions[this.currentQuestionIndex].question;

        if (this.currentQuestion.qtype == QTYPE_MULTIPLE_IMAGE) {
            template = Handlebars.compile($("#worldPlayMultipleImagesQuestionScreen").html());
            var multipleImagesStructure = {
                answer_1: 'col-xs-12',
                answer_2: 'col-xs-12',
                answer_3: 'col-xs-12',
                answer_4: 'col-xs-12'
            };

            if (this.currentQuestion.answer_4) {
                multipleImagesStructure.answer_1 = 'col-xs-6';
                multipleImagesStructure.answer_2 = 'col-xs-6';
                multipleImagesStructure.answer_3 = 'col-xs-6';
                multipleImagesStructure.answer_4 = 'col-xs-6';
            }
            else if (this.currentQuestion.answer_3) {
                multipleImagesStructure.answer_1 = 'col-xs-6';
                multipleImagesStructure.answer_2 = 'col-xs-6';
                multipleImagesStructure.answer_3 = 'col-xs-12';
            }
            this.currentQuestion.structure = multipleImagesStructure;

        }
        else if (this.currentQuestion.qtype == QTYPE_HOT_SPOT) {
            template = Handlebars.compile($("#worldPlayHotSpotQuestionScreen").html());
        }
        else if (this.currentQuestion.qtype == QTYPE_FREE_TEXT) {
            template = Handlebars.compile($("#worldPlayFreeTextQuestionScreen").html());
        }
        else {
            template = Handlebars.compile($("#worldPlayQuestionScreen").html());
        }

        //Borrar las notificaciones
        $('.btn-play').removeClass('btn-play').addClass('btn-play');
        $('.result-btn').hide();
        $('.alert').remove();
        $('#challengeAnswerBadge').removeClass('challengeAnswerBadgeCorrect').removeClass('challengeAnswerBadgeIncorrect').text('');
        $('#mediaContainer').empty().hide();
        $('body').removeClass('stop-scrolling');

        $('#questionContainer').css('height', '');
        $('#questionContainer').css('padding', '');

        var context = this.currentQuestion;
        context['searchIcon'] = customIcons["QUIESTION_IMAGE_ZOOM"];

        $("#questionContainer").html(template(this.currentQuestion));

        $('.answerBtn').shuffle();

        $('.play-info').css('background-color', '#' + this.currentQuestion.category.dark_color);

        if ($(".play-bottom").length > 0) {
            $('.quiz-content').addClass("enabled-wildcards");
        }

        if (this.currentQuestion.qtype == QTYPE_MULTIPLE_IMAGE || this.currentQuestion.qtype == QTYPE_HOT_SPOT || this.currentQuestion.qtype == QTYPE_FREE_TEXT) {
            $('.quiz-content').addClass('h-100-p')
        }
        else {
            // FIX Algunas veces el boton queda marcado nada mas cargar las respuestas
            $('.answerBtn').removeClass('hover');
            $('.answerBtn').css('background-color', '#' + this.currentQuestion.category.dark_color).addClass('btn-empty');
            $('.answerBtn').hover(function(){
                $(this).addClass('hover');
            }, function(){
                $(this).removeClass('hover');
            });
            $('.quiz-content').removeClass('h-100-p');
        }

        if (this.currentQuestion.category.color) {
            $('.play-top').css('background-color', '#' + this.currentQuestion.category.color);
        }

        $('#playCategoryIconImg').attr('src', this.currentQuestion.category.icon);
        $('#playCategoryNameTxt').text(this.currentQuestion.category.name);

        let height = 40;

        if ($(window).width() <= 420) {
            height = 30;
        }

        $('.play-category-title').dotdotdot({
            wrap: 'letter',
            watch: true,
            height: height,
        });

        this.imageContainerHeight();
        this.initCounter(result);

        this.countDown._drawStart('');
        var strategy = null;
        if (QuestionUtils.isTextQuestion(this.currentQuestion)) strategy = new TextQuestionStrategy(this, result);
        if (QuestionUtils.isImageQuestion(this.currentQuestion)) strategy = new ImageQuestionStrategy(this, result);
        if (QuestionUtils.isAudioQuestion(this.currentQuestion)) strategy = new AudioQuestionStrategy(this, result);
        if (QuestionUtils.isVideoQuestion(this.currentQuestion)) strategy = new VideoQuestionStrategy(this, result);
        if (QuestionUtils.isMultipleImageQuestion(this.currentQuestion)) strategy = new MultipleImageQuestionStrategy(this, result);
        if (QuestionUtils.isHotSpotQuestion(this.currentQuestion)) strategy = new HotSpotQuestionStrategy(this, result);
        if (QuestionUtils.isFreeTextQuestion(this.currentQuestion)) strategy = new FreeTextQuestionStrategy(this, result);
        this._currentStrategy = strategy;

        if (strategy) {
            if($('#simplifyWildcardLink').hasClass('locked-simplify')) {
                $('#simplifyWildcardLink').find('img').attr('src', customIcons['SIMPLIFY']);
                $('#simplifyWildcardLink').removeClass('disabled-link locked-simplify');
                $('#simplifyWildcardSection').find('p').addClass('black-text');

                $('#simplifyWildcardLink').bind("click");
            }

            strategy.draw(result);

            if (QuestionUtils.isTextQuestion(this.currentQuestion) || QuestionUtils.isImageQuestion(this.currentQuestion) || QuestionUtils.isAudioQuestion(this.currentQuestion)
                || QuestionUtils.isVideoQuestion(this.currentQuestion)) {
                strategy.hideAnswerButtonTexts();
            }

        }
        this.onCompleteTime = (strategy && strategy.onCompleteTime) ? strategy.onCompleteTime.bind(strategy) : undefined;
        this.onResolveWildcard = (strategy && strategy.onResolveWildcard) ? strategy.onResolveWildcard.bind(strategy) : undefined;

        let bottomHeight = $('#playBottom').outerHeight();
        $('.multiple-images-row').css('margin-bottom', bottomHeight);
    };

    startTimer(result) {
        if (this.currentQuestionIndex >= this.numQuestions) return;

        __playDebug.log(
            'TIMER_START',
            {
                qIndex: this.currentQuestionIndex
            }
        );
        $('.answerBtn').css('color', '#FFFFFF').removeClass('btn-empty');
        $('#questionContainer').off("click", '.answerBtn:not([data-launch-answer]), .answerBtn[data-launch-answer="false"]');
        this.manageAnswer(result);
        this.countDown.start();
        this.counterStartsAt = new Date().getTime();
    };

    manageAnswer(result) {

        var that = this;
        $('#questionContainer').one("click", '.answerBtn:not([data-launch-answer]), .answerBtn[data-launch-answer="false"]',
            function (event, no_show) {

                __playDebug.log(
                    'ANSWER_CLICK',
                    {
                        qIndex: that.currentQuestionIndex,
                        qId: that.currentQuestion?.id,
                        iteration: that.countDown?._iteration,
                        answered: that.questionAnswered
                    }
                );

                if (that.questionAnswered) return;
                that.questionAnswered = true;

                event.stopPropagation();
                var questionPoints;
                var responseTime;
                var answerType;
                var answer2 = '', answer3 = '', answer4 = '';
                var userAnswer = $(this).attr('data-answer');
                var correctAnswer = that.currentQuestion.correct_answer;

                if (no_show == undefined) {
                    no_show = false;
                }

                if (that.currentQuestion.answer_2) {
                    answer2 = that.currentQuestion.answer_2;
                }
                if (that.currentQuestion.answer_3) {
                    answer3 = that.currentQuestion.answer_3;
                }
                if (that.currentQuestion.answer_4) {
                    answer4 = that.currentQuestion.answer_4;
                }

                //Parar el contador y mirar cuantos segundos
                that.stopCountDown();                
                responseTime = that.countDown._iteration;

                if (correctAnswer == userAnswer) {
                    if(world.world_mode !== 'ASSESSMENT' && !result.has_test){

                        // Formula de los puntos
                        questionPoints = that.correctAnswerFormula(responseTime);

                        // Marcar la opcion seleccionada
                        if (that.currentQuestion.qtype == QTYPE_HOT_SPOT) {
                            $(this).addClass('box-shadow-green').addClass('hot-spot-green-div');
                        }
                        else {
                            $(this).addClass('green-btn').addClass('box-shadow-green');
                        }

                        // Mostrar la etiqueta CORRECTO/INCORRECTO
                        $('.correct').css('display', 'inline');

                    } else {
                        questionPoints = that.assessmentAnswerFormula(CORRECTANSWER);
                    }

                    $(this).find('img').css('opacity', '.6');

                    answerType = CORRECTANSWER;
                }
                else {
                    $(this).find('img').css('opacity', '.6');
                    if (userAnswer == answer2) {
                        answerType = ANSWER2;
                    }
                    else if (userAnswer == answer3) {
                        answerType = ANSWER3;
                    }
                    else if (userAnswer == answer4) {
                        answerType = ANSWER4;
                    }
                    else {
                        answerType = OTHERANSWER;
                    }

                    if(world.world_mode !== 'ASSESSMENT' && !result.has_test){

                        // Formula de los puntos
                        questionPoints = that.incorrectAnswerFormula(responseTime, world.question_response_max_time);

                        // Marcar la opcion seleccionada
                        if (that.currentQuestion.qtype == QTYPE_HOT_SPOT) {
                            if (!no_show) {
                                $(this).addClass('box-shadow-red').addClass('hot-spot-red-div');
                            }
                        } else {
                            $(this).addClass('red-btn').addClass('box-shadow-red');
                        }

                        // Mostrar la etiqueta CORRECTO/INCORRECTO
                        $('.incorrect').css('display', 'inline');

                        // Mostrar la opcion correcta
                        if (that.question_show_answer) {
                            if (that.currentQuestion.qtype == QTYPE_HOT_SPOT) {
                                $('*[data-answer="' + correctAnswer + '"]').addClass('box-shadow-green').addClass('hot-spot-green-div');
                            }
                            else {
                                $('*[data-answer="' + correctAnswer + '"]').addClass('green-btn').addClass('box-shadow-green');
                            }
                            $('*[data-answer="' + correctAnswer + '"]').find('img').css('opacity', '.6');
                        }

                    } else {
                        questionPoints = that.assessmentAnswerFormula(answerType);
                    }

                }

                if(world.world_mode === 'ASSESSMENT') {
                    $(this).addClass('answered-btn');
                }

                $(".answerBtn").unbind("click");
                that.createResponseQuestionObject(result.game.questions[that.currentQuestionIndex].question,
                    responseTime, answerType, questionPoints);


                // var r = confirm("Press a button!");
                // if (r == true) {
                __playDebug.log(
                    'ANSWER_PROCESSED',
                    {
                        qIndex: that.currentQuestionIndex,
                        answerType: answerType,
                        points: questionPoints
                    }
                );

                that.showNextQuestion(result);
                // }


            }
        )
    };

    showNextQuestion(result, delay) {
        // alert("SIGUIENTE QUESTION");
        var that = this;

         __playDebug.log(
            'SHOW_NEXT_QUESTION',
            {
                fromIndex: this.currentQuestionIndex,
                numQuestions: this.numQuestions,
                delay: delay,
                stack: new Error().stack.split('\n').slice(1,3)
            }
        );

        if (typeof delay == 'undefined') {
            if (typeof world.world_feedback_delay != 'undefined') {
                delay = world.world_feedback_delay;
            } else {
                delay = 1000;
            }
        }

        if (this.currentQuestionIndex >= this.numQuestions) return;
        
        //mostrara la siguiente pregunta o el fin del Quizz
        if (++this.currentQuestionIndex < this.numQuestions) {

            __playDebug.log(
                'NEXT_QUESTION_SCHEDULED',
                {
                    toIndex: this.currentQuestionIndex
                }
            );

            this.timeoutForStartTimer = setTimeout(function () {
                that.timeoutForStartTimer = undefined;
                try {
                    that.drawQuestion(result);
                } catch (e) {
                    console.error('PlayscreenController - showNextQuestion - drawQuestion failed', e, that.currentQuestionIndex);
                }
            }, delay);

        } else {
            __playDebug.log(
                'GAME_FINISHED',
                {
                    finalIndex: this.currentQuestionIndex
                }
            );

            that.completeRequest.game.category = result.game.category;

            this.questionAnswered = true;
            $('#questionContainer').off('click', '.answerBtn:not([data-launch-answer]), .answerBtn[data-launch-answer="false"]');

            this.stopCountDown();

            if (this.isChallenge) {
                setTimeout(function () {
                    api.sendCompleteChallenge(that.completeRequest);
                }, delay);

            } else {
                setTimeout(function () {
                    if(that.result.is_doc_game_or_test){
                        that.completeRequest.document_id = that.result.document_id;
                        api.sendCompleteDocTest(that.completeRequest);
                    } else if (that.result.is_doc_type_game_or_test) {
                        api.sendCompleteDocumentGame(that.completeRequest, that.result.document_id);
                    } else {
                        api.sendCompleteGame(that.completeRequest);
                    }
                }, delay);
            }
        }
    };

    initCounter(result) {
        var that = this;
        this.countDown = null;
        $('.timer-wrap').html('<div id="countdown" class="text-center"></div>');

        this.countDown = $("#countdown").countdown360({
            radius: 40,
            seconds: that.question_response_max_time,
            strokeWidth: 8,
            label: ["", ""],
            fillStyle: '#' + result.game.questions[that.currentQuestionIndex].question.category.color,
            strokeStyle: '#FFFFFF',
            fontSize: 20,
            fontColor: '#FFFFFF',
            autostart: false,
            onComplete: function () {
                __playDebug.log(
                    'TIMEOUT',
                    {
                        qIndex: that.currentQuestionIndex,
                        qId: result.game.questions[that.currentQuestionIndex]?.question?.id,
                        iteration: that.countDown?._iteration,
                        answered: that.questionAnswered
                    }
                );

                if (that.questionAnswered) return;
                that.questionAnswered = true;

                try {
                    if (that.onCompleteTime) that.onCompleteTime();
                    //La pregunta no ha sido contestada.
                    that.createResponseQuestionObject(result.game.questions[that.currentQuestionIndex].question,
                        world.question_response_max_time, TIMEOUT, that.incorrectAnswerFormula(world.question_response_max_time, world.question_response_max_time));
                    that.showNextQuestion(result);
                    // console.trace('completed task', result);
                } catch(e) {
                    __playDebug.error('TIMEOUT_EXCEPTION', e);
                }
            }
        });

        // Replace draw function so it rounds to 1/10 of a second
        this.countDown._draw = function () {
            //var secondsElapsed = Math.round((new Date().getTime() - this.startedAt.getTime())/1000);
            //var tenthsElapsed = Math.round((new Date().getTime() - this.startedAt.getTime())/100)/10;

            this._iteration += 100;
            var secondsElapsed = Math.round(this._iteration / 1000);

            var endAngle = (Math.PI * 3.5) - (((Math.PI * 2) / this.settings.seconds) * this._iteration / 1000);
            this._clearRect();
            this._drawCountdownShape(Math.PI * 3.5, false);
            if (this._iteration <= (that.question_response_max_time * 1000)) {
                this._drawCountdownShape(endAngle, true);
                this._drawCountdownLabel(secondsElapsed);
            } else {
                this._drawCountdownLabel(this.settings.seconds);
                this.stop();
                $('#questionContainer').off("click", '.answerBtn:not([data-launch-answer]), .answerBtn[data-launch-answer="false"]');
                this.settings.onComplete();
            }
        };

        // Proxy start function so it uses a smaller time interval
        var oldStart = this.countDown.start;
        this.countDown.start = function () {
            this._iteration = 0;
            oldStart.call(this);
            clearInterval(this.interval);
            this.interval = setInterval(jQuery.proxy(this._draw, this), 100);
        };
        this.resizeCircleTime();
    }

    draw(result) {
        $('.play-top').css('background-color', '#' + result.game.category.color);
        $('#resumeModalHeader').css('background-color', '#' + result.game.category.color);
        if (result.game.questions[this.currentQuestionIndex]) {
            this.drawQuestion(result);
        }
        this.extraTimeWildCard(result);
        this.simplifyWildCard(result);
        this.resolveWildCard(result);

        this.isChallenge ? ga('send', 'pageview', analytics.GA_SCREEN_CHALLENGES_GAME) : ga('send', 'pageview', analytics.GA_SCREEN_INDIVIDUAL_GAME);
        notificationSystem.canShowNotifications = false;

        //parche curita
        if (world.is_lms) {
            notificationSystem.canShowNotifications = true;
        }
    };

    createPreloader(iconUrl) {

        const preloaderColor = this.result.own_poll ? this.result.own_poll.color : this.currentQuestion.category.color;
        const cText = this.result.own_poll ? this.currentPollQuestionIndex + 1: this.currentQuestionIndex + 1;

        var preloader = $('<div>', {
            'class': 'multimedia-preloader-wrapper',
            'css': {
                'background-color': '#' + preloaderColor,
            }
        });

        var countDown = $('<div>', {
            'class': 'multimedia-preloader-countdown'
        }).appendTo(preloader);

        $(`<div class="multimedia-preloader-icon" style="background: url('` + iconUrl + `') center / contain no-repeat"></div><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="loader-1" x="0" y="0" width="128" height="128" viewBox="0 0 128 128" enable-background="new 0 0 128 128" xml:space="preserve">
            <path d="M64 6c31.98 0 58 26.02 58 58h6c0-35.35-28.65-64-64-64S0 28.65 0 64h6C6 32.02 32.02 6 64 6z">
                <animateTransform
                    attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 64 64"
                    to="360 64 64"
                    dur="1s"
                    repeatCount="indefinite" />
                </path>
            </svg>`).appendTo(countDown);

        var counter = $('<h4>', {'class': 'counter-preload'});

        counter.text(cText + '/' + this.result.game.questions.length);
        preloader.append(counter);
        return preloader;
    };

    imageContainerHeight() {
        const imageContainer = $(window).innerHeight() - ($('.play-top').outerHeight(true) + $('.play-info').outerHeight(true) + $('.question').outerHeight(true) + $('#playBottom').outerHeight(true));
        const imageHeight = imageContainer / 2;

        $('.multiple-images-col').each(function() {
            $(this).height(imageHeight);
        });
    }

    resizeCircleTime() {
        if($(window).width() <= 420) {
            $('#countdown > canvas').css('height', 69);
            $('#countdown > canvas').css('width', 69);
        } else {
            $('#countdown > canvas').css('height', 96);
            $('#countdown > canvas').css('width', 96);
        }
    }

    // ==================================================================================================== //
    // METODOS POLL                                                                                         //
    // ==================================================================================================== //

    drawPoll(result) {

        if (result.game.questions[this.currentPollQuestionIndex]) {
            this.drawQuestionPoll(result);
        }

        notificationSystem.canShowNotifications = false;

    };

    drawQuestionPoll(result) {

        const that = this;
        let template = null;
        let strategy = {};

        if (this._trackingDocumentId) {
            this._trackingCheckpointAt = Date.now();
            this._trackingCheckpointConsumed = false;
        }

        this.currentQuestion = result.game.questions[this.currentPollQuestionIndex].question;
        template = Handlebars.compile($("#worldPollQuestionScreen").html());

        this.manageProgressPoll();

        $('.btn-play').removeClass('btn-play').addClass('btn-play');
        $('#mediaContainer').empty().hide();
        $('body').removeClass('stop-scrolling');

        $('#questionContainer').css('height', '');
        $('#questionContainer').css('padding', '');
        $("#questionContainer").html(template(this.currentQuestion));

        $('.answerBtn').removeClass('hover');
        $('.answerBtn').addClass('btn-empty');
        $('.answerBtn').hover(function(){
            $(this).addClass('hover');
        }, function(){
            $(this).removeClass('hover');
        });
        $('.quiz-content').removeClass('h-100-p');

        this.imageContainerHeight();

        if (QuestionUtils.isTextQuestion(this.currentQuestion)) {
            strategy = new TextQuestionStrategy(this, result);
        }
        if (QuestionUtils.isImageQuestion(this.currentQuestion)) {
            strategy = new ImageQuestionStrategy(this, result);
        }
        if (QuestionUtils.isAudioQuestion(this.currentQuestion)) {
            strategy = new AudioQuestionStrategy(this, result);
        }
        if (QuestionUtils.isVideoQuestion(this.currentQuestion)) {
            strategy = new VideoQuestionStrategy(this, result);
        }

        if (strategy) {

            strategy.draw();

            if (QuestionUtils.isTextQuestion(this.currentQuestion) || QuestionUtils.isImageQuestion(this.currentQuestion) || QuestionUtils.isAudioQuestion(this.currentQuestion) || QuestionUtils.isVideoQuestion(this.currentQuestion)) {
                strategy.hideAnswerButtonTexts();
            }

        }

    }

    startTimerPoll(result) {

        if (this.result.poll_end_resume) {
            this.showQuestionFeedbackPoll();
        } else {
            $('.answerBtn').css('color', '#FFFFFF').removeClass('btn-empty');
            $('#questionContainer').off("click", '.answerBtn:not([data-launch-answer]), .answerBtn[data-launch-answer="false"]');
            this.manageAnswerPoll(result);
        }

    };

    manageAnswerPoll(result) {

        const that = this;

        $('#questionContainer').one("click", '.answerBtn:not([data-launch-answer]), .answerBtn[data-launch-answer="false"]', function (event) {

            event.stopPropagation();

            let userAnswer = $(this).attr('data-answer');
            let answerType = null;

            if (that.currentQuestion.answer_1 && userAnswer === that.currentQuestion.answer_1) {
                answerType = ANSWER1;
            }
            if (that.currentQuestion.answer_2 && userAnswer === that.currentQuestion.answer_2) {
                answerType = ANSWER2;
            }
            if (that.currentQuestion.answer_3 && userAnswer === that.currentQuestion.answer_3) {
                answerType = ANSWER3;
            }
            if (that.currentQuestion.answer_4 && userAnswer === that.currentQuestion.answer_4) {
                answerType = ANSWER4;
            }

            $(".answerBtn").unbind("click");

            that.createResponseQuestionObject(result.game.questions[that.currentPollQuestionIndex].question, 0, answerType, 0);
            that.showNextQuestionPoll(result, answerType);

        });

    }

    showNextQuestionPoll(result, userAnswer) {

        const that = this;
        const delay = 500;

        setTimeout(function () {

            if (that.currentPollQuestionIndex + 1 < that.numQuestions) {

                if (that.result.own_poll.poll_mode === 'NO_FEEDBACK' || that.result.own_poll.poll_mode === 'END_RESUME') {
                    that.currentPollQuestionIndex += 1;
                    that.drawQuestionPoll(result);
                }

                if (that.result.own_poll.poll_mode === 'IMMEDIATE_FEEDBACK') {
                    that.showQuestionFeedbackPoll(userAnswer);
                }

            } else {

                that.completeRequest.game.category = result.game.category;

                if (that.result.own_poll.poll_mode === 'NO_FEEDBACK' || that.result.own_poll.poll_mode === 'END_RESUME') {
                    api.sendCompleteDocumentGame(that.completeRequest, that.result.document_id);
                }

                if (that.result.own_poll.poll_mode === 'IMMEDIATE_FEEDBACK') {
                    that.showQuestionFeedbackPoll(userAnswer);
                }

            }
        }, delay);
    };

    manageProgressPoll() {

        const progressText = $('.questions-text-progress');
        const progressBar = $('.completed-percent');
        const progresBarPercent = ((this.currentPollQuestionIndex + 1) / this.numQuestions) * 100;

        progressText.text(sprintf(Translator.trans('TR_PREGUNTA_DE'), this.currentPollQuestionIndex + 1, this.numQuestions));
        progressBar.width(progresBarPercent + '%');

    }

    showQuestionFeedbackPoll(userAnswer = null) {

        const that = this;
        const totalPercentage = 100;
        const template = Handlebars.compile($("#worldPollQuestionResultScreen").html());
        let participants = 0;
        let selectedAnswer = 0;

        if (that.result.poll_end_resume) {
            selectedAnswer = window[that.currentQuestion.selected_answer.toUpperCase().replace('_', '')];
            participants = parseInt(that.currentQuestion.participants);
        } else {
            selectedAnswer = userAnswer;
            participants = parseInt(that.currentQuestion.participants) + 1;

            if (userAnswer === ANSWER1) {
                that.currentQuestion.number_entries.answer_1 = parseInt(that.currentQuestion.number_entries.answer_1 || 0) + 1;
            }
            if (userAnswer === ANSWER2) {
                that.currentQuestion.number_entries.answer_2 = parseInt(that.currentQuestion.number_entries.answer_2 || 0) + 1;
            }
            if (userAnswer === ANSWER3) {
                that.currentQuestion.number_entries.answer_3 = parseInt(that.currentQuestion.number_entries.answer_3 || 0) + 1;
            }
            if (userAnswer === ANSWER4) {
                that.currentQuestion.number_entries.answer_4 = parseInt(that.currentQuestion.number_entries.answer_4 || 0) + 1;
            }
        }

        const answer1Percent = formatValueByLocale((parseInt(that.currentQuestion.number_entries.answer_1 || 0) / participants) * 100);
        const answer2Percent = formatValueByLocale((parseInt(that.currentQuestion.number_entries.answer_2 || 0) / participants) * 100);
        const answer3Percent = formatValueByLocale((parseInt(that.currentQuestion.number_entries.answer_3 || 0) / participants) * 100);
        const answer4Percent = formatValueByLocale(totalPercentage - parseFloat(answer1Percent.replace(',', '.')) - parseFloat(answer2Percent.replace(',', '.')) - parseFloat(answer3Percent.replace(',', '.')));

        $(".question-answers-wrapper").addClass('poll');

        $(".question-answers-wrapper").html(template({
            currentQuestion: that.currentQuestion,
            answer1VotesPercent: answer1Percent,
            answer2VotesPercent: answer2Percent,
            answer3VotesPercent: answer3Percent,
            answer4VotesPercent: answer4Percent,
            endResume: that.result.poll_end_resume,
            firstQuestion: that.currentPollQuestionIndex === 0,
            lastQuestion: that.currentPollQuestionIndex + 1 >= that.numQuestions,
            selectedAnswer: selectedAnswer,
            participants: participants
        }));

        const playTopHeight = $('.play-top.poll').height();
        const playInfoHeight = $('.play-info.poll').height();
        const questionHeight = $('.question').outerHeight();
        const questionWrapperMargin = parseInt($('.question-answers-wrapper.poll').css('margin-top')) + parseInt($('.question-answers-wrapper.poll').css('padding-top'));
        const buttonHeightSpace = 175;

        $('.questions-responses-container').css('min-height', ($(window).height() - playTopHeight - playInfoHeight - questionHeight - questionWrapperMargin - buttonHeightSpace + 'px'));
        $(window).off('resize.answersContainer').on('resize.answersContainer', function() {
            $('.questions-responses-container').css('min-height', ($(window).height() - playTopHeight - playInfoHeight - questionHeight - questionWrapperMargin - buttonHeightSpace + 'px'));

        });

        $(document).off('click.nextQuestionImmediateFeedback').one('click.nextQuestionImmediateFeedback', '.feedback-button.immediate-feedback.next-question', function() {
            that.currentPollQuestionIndex += 1;
            that.drawQuestionPoll(that.result);
        });

        $(document).off('click.endPoll').one('click.endPoll', '.feedback-button.immediate-feedback.end-poll', function() {
            api.sendCompleteDocumentGame(that.completeRequest, that.result.document_id);
        });

        $(document).off('click.nextQuestionEndResume').one('click.nextQuestionEndResume', '.feedback-button.end_resume.next-question', function() {
            that.currentPollQuestionIndex += 1;
            that.drawQuestionPoll(that.result);
        });

        $(document).off('click.prevQuestionEndResume').one('click.prevQuestionEndResume', '.feedback-button.end_resume.prev-question', function() {
            that.currentPollQuestionIndex -= 1;
            that.drawQuestionPoll(that.result);
        });

    }

}